import { InsuranceType } from "../constants";
import { PHASE } from "../routeConfig";
import useAppSelector from "./useAppSelector";
import useCanShowMidFunnelAds from "../features/configuration/useCanShowMidFunnelAds";
import useUnlinkedApplicationEntryRoute from "../features/unlinked-application/useUnlinkedApplicationEntryRoute";
export default function useForgotPasswordRoute(insuranceType) {
    if (insuranceType === void 0) { insuranceType = InsuranceType.Auto; }
    var selectedIssuer = useAppSelector(function (state) { return state.applicant; }).currentIssuer.auto;
    var canShowMidFunnelAds = useCanShowMidFunnelAds();
    var _a = useAppSelector(function (state) { return state.configuration; }), enableFormExperience = _a.enableFormExperience, isSavvyWidget = _a.isSavvyWidget, policyOnly = _a.policyOnly;
    var unlinkedEntryRoute = useUnlinkedApplicationEntryRoute(insuranceType);
    if (enableFormExperience) {
        return unlinkedEntryRoute;
    }
    if (canShowMidFunnelAds && Boolean(selectedIssuer === null || selectedIssuer === void 0 ? void 0 : selectedIssuer.id)) {
        return insuranceType === InsuranceType.Home
            ? PHASE.HOME_MID_FUNNEL_ADS
            : PHASE.MID_FUNNEL_ADS_FORGOT_PASSWORD;
    }
    if (isSavvyWidget && policyOnly) {
        return PHASE.UNQUALIFIED;
    }
    return PHASE.FORGOT_PASSWORD;
}
